export enum GLEnvironment {
  LOCAL = 'local',
  LOCALQA = 'localqa',
  DEV = 'dev',
  QA = 'qa',
  STAGING = 'staging',
  DEMO = 'demo',
  PRODUCTION = 'production',
}

export interface GrowelabEnv {
  environment: GLEnvironment;
  production: boolean;
  codoxApiKey: string;
  froalaKey: string;
  apiUrl: string;
  pusher: {
    key: string;
    cluster: string;
  };
  googleAnalyticsID: string;
  microsoftClarityID?: string;
  SENTRY_ORG?: string;
  SENTRY_PROJECT?: string;
  SENTRY_KEY?: string;
  growelabGoogleClientId: string;
  cleverClientId: string;
  cleverRedirectURI: string;
}
